module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessDelete(_vm.FUNCTIONALITY)) ? _c('div', [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('FormSectionTitle', {
    attrs: {
      "title": 'Update Forecast'
    }
  }), _vm._v(" "), (_vm.forecast && _vm.localForecast) ? _c('ForecastForm', {
    attrs: {
      "forecast": _vm.localForecast,
      "is-update": true,
      "brand-with-campaigns": _vm.brandWithCampaigns,
      "ref-date-is-equal-to-availability-date": _vm.refDateIsEqualToAvailabilityDate
    },
    on: {
      "update": _vm.onUpdate
    }
  }) : _vm._e(), _vm._v(" "), _c('section', [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.updateForecast
    }
  }, [_vm._v("Save Forecast")]), _vm._v(" "), _c('ClientColorButton', {
    on: {
      "click": function($event) {
        _vm.$emit('close', {
          updated: false
        })
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('br')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4fde41e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/ForecastEdit.vue
// module id = 3387
// module chunks = 0